import styled from 'styled-components';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: ${({ predictionStart }) => predictionStart} 1fr;
    background: ${({ predictionStart }) => `linear-gradient(90deg,
        rgba(255,255,255,0) 0%,
        rgba(255,255,255,0) ${predictionStart},
        rgba(247,245,253,1) ${predictionStart},
        rgba(247,245,253,1) 100%
    )`};
    grid-template-areas: 'historical prediction' 'chart chart';
`;

export default Wrapper;
